module.exports = __webpack_public_path__ + "img/guardian_default.1e036a38.png";